import React, { memo, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useMatches } from "react-router-dom";
import PropTypes from "prop-types";
import { validators } from "investira.sdk";
import { Loading, CenterInView } from "investira.react.components";
import services from "../../../services";
import app from "../../../utils/app";

import {
  acUserUpdate,
  acInfoChange,
  acEntidadeChanged,
  acIndicadoresChanged,
  acCarteirasChanged,
  acMercadosChanged,
  acReportsEnquadramentoRegrasChanged,
  acOutputsEnumChanged,
  acReportsEnquadramentosChanged,
} from "../../../store/actions";
// import { countNewNotifications } from '../../../../utils/helpers';
import { ErrorDataView } from "../../../components/molecules";

import withResponseHandling from "../../../hoc/withResponseHandling";

const Preload = memo((props) => {
  const dispatch = useDispatch();
  //const location = useLocation();

  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);

  function verifyToken() {
    services.info.read(
      {},
      () => {
        preload();
      },
      () => {
        app.logout();
      }
    );
  }

  function feedRedux(pResponses) {
    try {
      const xDispatches = [
        (pData) => dispatch(acUserUpdate(pData)),
        (pData) => dispatch(acInfoChange(pData)),
        (pData) => dispatch(acEntidadeChanged(pData)),
        (pData) => dispatch(acIndicadoresChanged(pData)),
        (pData) => dispatch(acCarteirasChanged(pData)),
        (pData) => dispatch(acMercadosChanged(pData)),
        (pData) => dispatch(acReportsEnquadramentoRegrasChanged(pData)),
        (pData) => dispatch(acOutputsEnumChanged(pData)),
        (pData) => dispatch(acReportsEnquadramentosChanged(pData)),
      ];

      pResponses.forEach((pData, pIndex) => {
        xDispatches[pIndex](pData);
      });

      setDataLoaded(true);
    } catch (error) {
      console.error("Preload => feedRedux()", error.message);
      return error;
    }
  }

  async function baseRequest(pService, pParams = {}) {
    return await pService(
      { ...pParams },
      (rRes) => {
        return rRes.data;
      },
      (rErr) => {
        throw rErr;
      }
    );
  }

  async function preload() {
    const xRequests = [
      baseRequest(services.user.read),
      baseRequest(services.info.read),
      baseRequest(services.entidades.usuario.entidades),
      baseRequest(services.indicadores.list),
      baseRequest(services.carteiras.list, {
        favorito: 1,
      }),
      baseRequest(services.ativosbase.mercado),
      baseRequest(services.enquadramentosRegras.sys),
      baseRequest(services.outputs.enumaration),
      baseRequest(services.enquadramentos.list),
    ];

    await Promise.all(xRequests)
      .then((rResponses) => {
        feedRedux(rResponses);
      })
      .catch((rErr) => {
        const xCallbacks = {
          err400: () => setError(true),
          err404: () => setError(true),
          err500: () => setError(true),
        };
        props.responseErrorHandling(rErr, xCallbacks);
      });
  }

  function handleRetry() {
    setError(null);
    verifyToken();
  }

  // Testa o token e inicia o preload
  useEffect(() => {
    props.isLoggedIn && verifyToken();
  }, [props.isLoggedIn]);

  if (!validators.isNull(error)) {
    return <ErrorDataView handleClick={handleRetry} />;
  }

  if (props.isLoggedIn === false) {
    return props.children;
  }

  if (dataLoaded) {
    return props.children;
  } else {
    return (
      <CenterInView>
        <Loading />
      </CenterInView>
    );
  }
});

Preload.propTypes = {
  children: PropTypes.element,
};

Preload.defaultProps = {};

Preload.displayName = "Preload";

export default withResponseHandling(Preload);
